<template>
  <Layout>
    <Card class="w-full">
      <template slot="header">
        <div class>
          <h3 class="is-size-4 has-text-weight-bold">
            Transferir puntos por CSV
          </h3>
        </div>
      </template>
      <template slot="content">
        <div v-if="!draft">
          <b-notification type="is-warning" has-icon :closable="false">
            No hay ningún archivo cargado. Vuelve a la página de transferencia y
            sube un CSV.
          </b-notification>
          <Button
            tag="router-link"
            :to="{ name: 'puntos-weeare-stock-transfer' }"
            variant="main"
          >
            Volver
          </Button>
        </div>
        <div v-else>
          <b-field label="Bolsa de puntos" style="max-width: 360px;">
            <b-select
              placeholder="Selecciona una bolsa"
              v-model="selectedBag"
              expanded
            >
              <option
                v-for="point in draft.pointList"
                :key="point.id"
                :value="point"
              >
                {{ point.points_available }} (vence:
                {{ formatDate(point.expiration_date) }})
              </option>
            </b-select>
          </b-field>

          <b-notification
            type="is-info"
            has-icon
            :closable="false"
            class="mt-4"
          >
            Se cargaron {{ draft.rows.length }} cliente(s), un total de
            {{ totalPoints }} puntos a transferir desde la bolsa de
            {{ selectedBag.points_available }} puntos disponibles.
            <span v-if="draft.errors.length">
              <br />
              Se ignorarán {{ draft.errors.length }} fila(s) con datos
              inválidos: línea(s)
              {{
                draft.errors
                  .slice(0, 5)
                  .map(e => e.line)
                  .join(", ")
              }}
              <span v-if="draft.errors.length > 5">…</span>
            </span>
          </b-notification>
          <b-notification
            v-if="notEnoughPoints"
            type="is-danger"
            has-icon
            :closable="false"
          >
            No tienes suficientes puntos disponibles en la bolsa seleccionada
            para completar esta transferencia.
          </b-notification>

          <b-table
            :data="draft.rows"
            :paginated="draft.rows.length > 10"
            per-page="10"
            hoverable
            striped
          >
            <b-table-column field="codigo" label="Código" v-slot="props">
              {{ props.row.codigo }}
            </b-table-column>
            <b-table-column field="points" label="Puntos" v-slot="props">
              {{ props.row.points }}
            </b-table-column>
          </b-table>

          <b-field
            label="Nombre de la campaña"
            class="mt-4"
            style="max-width: 360px;"
          >
            <b-input
              v-model="campaignName"
              placeholder="Nombre de la campaña"
            />
          </b-field>

          <div
            class="is-flex is-justify-content-flex-end w-full is-align-items-center mt-4"
          >
            <div>
              <Button variant="gray" @click.native="cancel">
                Cancelar
              </Button>
            </div>
            <div class="ml-3">
              <Button
                variant="main"
                :spinner="isSubmitting"
                :disabled="
                  !campaignName ||
                    !selectedBag ||
                    draft.rows.length === 0 ||
                    notEnoughPoints ||
                    isSubmitting
                "
                @click.native="submit"
              >
                Transferir
              </Button>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
import Card from "@/components/base/Card";
import Button from "@/components/form/Button";
import PointService from "@/services/puntos/PointService";

export default {
  name: "StockTransferBulk",
  components: {
    Layout,
    Card,
    Button
  },
  data() {
    return {
      isSubmitting: false,
      campaignName: "",
      selectedBag: null
    };
  },
  computed: {
    draft() {
      return this.$store.state.pointsTransfer.csvDraft;
    },
    totalPoints() {
      if (!this.draft) {
        return 0;
      }
      return this.draft.rows.reduce((total, row) => total + row.points, 0);
    },
    notEnoughPoints() {
      if (!this.draft || !this.selectedBag) {
        return false;
      }
      return this.totalPoints > this.selectedBag.points_available;
    }
  },
  created() {
    if (this.draft) {
      this.campaignName = this.draft.name || "";
      this.selectedBag = this.draft.bag;
    }
  },
  methods: {
    formatDate(fechaOriginal) {
      if (fechaOriginal) {
        const partes = fechaOriginal.split(" ");
        const fecha = partes[0];
        const partesFecha = fecha.split("-");
        const dia = partesFecha[0];
        const mes = partesFecha[1];
        const año = partesFecha[2];
        return `${mes}/${dia}/${año}`;
      }
      return "";
    },
    cancel() {
      this.$store.commit("pointsTransfer/CLEAR_CSV_DRAFT");
      this.$router.push({ name: "puntos-weeare-stock-transfer" });
    },
    async submit() {
      this.isSubmitting = true;
      try {
        const formData = new FormData();
        formData.append("file", this.draft.file);
        formData.append("name", this.campaignName);
        formData.append("description", this.campaignName);
        formData.append("bag_point_id", this.selectedBag.id);
        await PointService.postTransferPointsCsv(formData);
        this.$store.commit("settings/SET_ALERT", {
          isAlert: true,
          type: "S",
          msg: "Se transfirieron los puntos correctamente"
        });
        this.$store.commit("pointsTransfer/CLEAR_CSV_DRAFT");
        this.$router.push({ name: "puntos-weeare-stock" });
      } catch (error) {
        const msg =
          (error.response &&
            error.response.data &&
            error.response.data.error) ||
          "Ocurrió un error al transferir los puntos";
        this.$store.commit("settings/SET_ALERT", {
          isAlert: true,
          type: "D",
          msg
        });
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>
